import { Switch } from "@headlessui/react"
import { OptionValue, ProductOption } from "@lib/swell/storefront-data-hooks/src/types"
import { classNames } from "core/utils"
import { useFormikContext, useField } from "formik"
import Image from "next/image"
import { useState, useEffect } from "react"
import { getPrice } from "@lib/swell/storefront-data-hooks/src/utils/product"

interface ToggleWithImageFieldProps {
  option: ProductOption
  updateSelectionChange: any
  currentlyEnabled: boolean
}
const ToggleWithImageField = ({
  option,
  updateSelectionChange,
  currentlyEnabled,
}: ToggleWithImageFieldProps) => {
  const { name, description } = option
  const optionValue = option.values[0]
  const optionValueId = optionValue.id
  const { isSubmitting } = useFormikContext()
  const [input] = useField(name)
  const [enabled, setEnabled] = useState(currentlyEnabled)

  const imageSizeClasses = () => {
    switch (option.image_size) {
      case "xs":
        return "sm:aspect-w-5 sm:aspect-h-2"
      case "s":
        return "sm:aspect-w-5 sm:aspect-h-3"
      case "md":
        return "sm:aspect-w-5 sm:aspect-h-4"
      case "lg":
        return "sm:aspect-w-5 sm:aspect-h-5"
      default:
        return "sm:aspect-w-5 sm:aspect-h-3"
    }
  }
  return (
    <div className="flex flex-col overflow-hidden rounded-lg border border-gray-300">
      <div
        className={classNames(
          "aspect-h-1 aspect-w-2 overflow-hidden rounded-t-lg",
          imageSizeClasses()
        )}
      >
        <Image
          quality="85"
          src={option.image.url}
          alt={option.name}
          className="object-cover object-center"
          loading="lazy"
          fill={true}
        />
      </div>

      <div className="mt-4 p-4">
        <Switch.Group as="div" className="flex flex-col justify-between space-y-4">
          <span className="flex grow flex-col space-y-2">
            <Switch.Label as="span" className="text-sm font-medium text-gray-900" passive>
              {name}
            </Switch.Label>

            <Switch.Description as="span" className="text-sm text-gray-500">
              {description}
            </Switch.Description>
          </span>
          {/* @ts-ignore */}
          <span className="flex">
            <Switch
              {...input}
              disabled={isSubmitting}
              onChange={(value: boolean) => {
                setEnabled(value)
                input.onChange({ target: { value, name } })
                updateSelectionChange(name, optionValueId, value)
              }}
              checked={enabled}
              className={classNames(
                enabled ? "bg-primary-600" : "bg-gray-200",
                "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              )}
            >
              <span
                aria-hidden="true"
                className={classNames(
                  enabled ? "translate-x-5" : "translate-x-0",
                  "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out"
                )}
              />
            </Switch>
            <div className="grow" />
            <span className="text-xs text-gray-500">
              {optionValue.price ? ` ${getPrice(optionValue.price, "usd")}` : <></>}
            </span>
          </span>
        </Switch.Group>
      </div>
    </div>
  )
}
export default ToggleWithImageField
